const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const API = {
  BASE,
  AUTH:            `${BASE}/auth`,
  PROJECTS:        `${BASE}/projects`,
  EVALUATIONS:     `${BASE}/evaluations`,
  EFFECTS:         `${BASE}/effects`,
  OPTIONS:         `${BASE}/options`,
  ACTORS:          `${BASE}/actors`,
  CATALOG_EFFECTS: `${BASE}/catalog-effects`,
  STRUCTURATION:   `${BASE}/structuration`,
  INDICATORS:      `${BASE}/indicators`,
  REPORTS:         `${BASE}/reports`,
  REPORT_NOTES:    `${BASE}/reportNotes`,
  COST_BENEFIT:    `${BASE}/cost-benefit`,
  AMC:             `${BASE}/evaluations`,   // /api/evaluations/:id/amc/*
  LISTS: {
    BASE:               `${BASE}/lists`,
    SECTORS:            `${BASE}/lists/sectors`,
    MINISTRIES:         `${BASE}/lists/ministries`,
    REGIONS:            `${BASE}/lists/regions`,
    DEPARTMENTS:        `${BASE}/lists/departments`,
    COMMUNES:           `${BASE}/lists/communes`,
    INTERVENTION_TYPES: `${BASE}/lists/interventionTypes`,
    STRUCTURE_TYPES:    `${BASE}/lists/structureTypes`,
    FUNDING_TYPES:      `${BASE}/lists/fundingTypes`,
    DOCUMENT_TYPES:     `${BASE}/lists/documentTypes`,
  },
  STATS: {
    PROJECTS:     `${BASE}/stats/projects`,
    EVALUATIONS:  `${BASE}/stats/evaluations`,
  },
};

export default API;
